export const convertBlobToBase64 = async (blob: Blob): Promise<string | ArrayBuffer | null> => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return await new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};
